import { useDispatch, useSelector } from "react-redux";
import { setProfil, setWait } from "../redux";

export const useMe = () => {
    const dispatch = useDispatch();
    const wait = useSelector(state => state.site.wait);

    const getMe = async () => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (!token || wait > 0) return;
        
        dispatch(setWait(1));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/me`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const res = await req.json();
        dispatch(setWait(-1));

        if (req.status === 200) {
            dispatch(setProfil(res));
            return
        }

        localStorage.removeItem('save_login');
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
    }
    return getMe;
};